<div *ngIf="isLoading" style="height: 400px; display: flex; align-items: center; justify-content: center;">
  <mat-spinner diameter="40"></mat-spinner>
</div>
<div *ngIf="!isLoading && hasData" echarts [options]="chartOption" [merge]="chartOption" [autoResize]="true" style="height: 400px; width: 100%; max-width: 100%;"></div>
<div *ngIf="!isLoading && !hasData" style="height: 400px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 8px;">
  <p style="color: #666; font-size: 16px;">No crop spray data available</p>
</div>
